import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { AddPartBomButton, PartBomList } from 'partBoms/components';

export const PartBomListPage = () => {
  const { t } = useTranslation();

  const buttons = useMemo(() => {
    return [<AddPartBomButton key="addPartBom" />];
  }, []);

  return (
    <PageLayout title={t('titlePartBomList')} hasGlobalSearch={false}>
      <>
        <PageTitle title={t('titlePartBomList')} buttons={buttons} />

        <PartBomList />
      </>
    </PageLayout>
  );
};
